export const fonts = {
    family: {
        primary:
            "Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', sans-serif",
    },
    weight: {
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
    },

    Smaller: {
        fontSize: 10,
        lineHeight: 12.5,
        fontWeight: 400,
    },
    SmallerBold: {
        fontSize: 10,
        lineHeight: 12.5,
        fontWeight: 700,
    },
    Small: {
        fontSize: 12,
        lineHeight: 15,
        fontWeight: 400,
    },
    SmallMedium: {
        fontSize: 12,
        lineHeight: 15,
        fontWeight: 500,
    },
    SmallBold: {
        fontSize: 12,
        lineHeight: 15,
        fontWeight: 700,
    },
    Normal: {
        fontSize: 14,
        lineHeight: 17.5,
        fontWeight: 400,
    },
    NormalMedium: {
        fontSize: 14,
        lineHeight: 17.5,
        fontWeight: 500,
    },
    NormalBold: {
        fontSize: 14,
        lineHeight: 17.5,
        fontWeight: 700,
    },
    Big: {
        fontSize: 16,
        lineHeight: 20,
        fontWeight: 400,
    },
    BigBold: {
        fontSize: 16,
        lineHeight: 20,
        fontWeight: 700,
    },
    Bigger: {
        fontSize: 20,
        lineHeight: 25,
        fontWeight: 400,
    },
    BiggerBold: {
        fontSize: 20,
        lineHeight: 25,
        fontWeight: 700,
    },
}
